/**
 * Helper to provide a scrollUp and scrollDown event fired on the window object
 * @type {ScrollDirectionEventDispatcher}
 */
export class ScrollDirectionEventDispatcher {
    constructor() {
        this.previousScrollY = window.scrollY

        window.addEventListener('scroll', () => {
            let event = null
            // Scrolling down
            if (window.scrollY > this.previousScrollY) {
                //Hide header
                event = new Event('scrollDown')
            }

            // Scrolling up
            if (window.scrollY < this.previousScrollY) {
                event = new Event('scrollUp')
            }

            if (event !== null) {
                window.dispatchEvent(event)
            }

            // Current position is saved for next comparison
            this.previousScrollY = window.scrollY
        })
    }
}
